import Error from '../common/errorData'
import CON from '../constant'
// import handleAjax from '../common/handleajax';
// import catchFn from '../common/catch';
import {
  http
} from './index'
const pasurl = CON.URL_DOWN

const getReq = (url, data) => { // 封装get参数
  const urls = http.adornUrl(url, pasurl)
  return http.get(urls, {
    params: data
  })
}
const postReq = (url, data) => { // 封装get参数
  const urls = http.adornUrl(url, pasurl)
  return http.post(urls, data)
}

export default {
  // 获取首页轮播图列表
  searchContent: (data) => getReq('/ndata/pc/home/searchContent', data).then(Error),
  pageContentMainByColumnId: (data) => getReq('/pc-api/cms/content-main/page', data).then(Error),
  pageContentMainByParentId: (data) => getReq('/ndata/pc/home/pageContentMainByParentId', data).then(Error),
  getParentColumn: (data) => getReq('/pc-api/cms/column/getColumn', data).then(Error),
  // 专题
  pageHomeSpecial: (data) => getReq('/ndata/pc/special/pageHomeSpecial', data).then(Error),
  // 热门课程
  getPopularCourseClassList: (data) => getReq('/pc-api/cms/special/getPopularCourseClassList', data).then(Error),
  // 友情链接
  getFriendshipLinkList: (data) => getReq('/pc-api/cms/friendship-link/getFriendshipLinkList', data).then(Error),
  // 获取首页轮播图列表
  listAds: (data) => getReq('/pc-api/cms/ads/page', data).then(Error),
  listHomeVideozone: (data) => getReq('/pc-api/cms/special/home_page', data).then(Error),
  // 获取站点信息
  getWebsit: (data) => getReq('/pc-api/cms/websit/getWebsitByTenantId', data).then(Error),
  getLoginConfig: (data) => getReq('/pc-api/cms/websit/getLoginConfigByTenantId', data).then(Error),
  getPopularCourses: (data) => getReq('/app-api/app/course/index.action', data).then(Error),
  pseudoLogin: (data) => postReq('/subscriber-api/forgot/login/pseudoLogin.action', data).then(Error),
  getColumnByColumnName: (data) => getReq('/pc-api/cms/column/getColumnByColumnName', data).then(Error),

}



// WEBPACK FOOTER //
// ./src/apis/home.js